import React from 'react'
import './Assets/Css/style.css'
import Dashboard from './Pages/Dashboard';
import InactivityHandler from './Store/InactivityHandler';
import { BrowserRouter } from 'react-router-dom'


const App = () => {
  
  return (
    <React.Fragment>
      <InactivityHandler />
      <Dashboard />
    </React.Fragment>
  )
}

export default App;